module.exports = __webpack_public_path__ + "img/dashboard.371ba959.png";